import { render } from "./en.vue?vue&type=template&id=50c64f62&scoped=true&ts=true"
import script from "./en.vue?vue&type=script&lang=ts"
export * from "./en.vue?vue&type=script&lang=ts"

import "./en.vue?vue&type=style&index=0&id=50c64f62&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c64f62"]])

export default __exports__